export const knowledgePrimary = '#9013FE';
export const activityPrimary = '#FF5F4E';
